import { Card, Image } from "antd";
import color from "../../../../../theme/color";
import { noImageSrc } from "../../../Image/noImage";

interface ProductThumbnailProps {
  src?: string;
}

/**
 * 상품썸네일
 * @param param0
 * @returns
 */
export const ProductThumbnail: React.FC<ProductThumbnailProps> = ({ src }) => {
  return (
    <Card
      bodyStyle={{
        padding: 14,
        background: color.gray11,
        width: 88,
        height: 88,
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        borderRadius: 8,
        overflow: "hidden",
      }}
      bordered={false}
    >
      <Image preview={false} width={60} src={src} fallback={noImageSrc} />
    </Card>
  );
};
